module.exports = __webpack_public_path__ + "img/cs4.d583522f.png";